import axios from '@axios'
import Vue from 'vue'

const vm = new Vue()

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchQcRejects(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/auth/qc-rejects', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    importQcRejects(ctx, file) {
      const formData = new FormData()
      formData.append('uploaded_file', file)

      return new Promise((resolve, reject) => {
        axios
          .post('/api/auth/qc-rejects/import-excel', formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            const warnings = response.data.warnings || []
            const warningText = warnings.length
              ? ` ${warnings.length} warning: ${warnings.slice(0, 3).join(' ')}`
              : ''

            vm.$bvToast.toast(
              `${response.data.total_imported || 0} data QC Reject berhasil diimport.${warningText}`,
              { title: 'QC Reject Imported' },
            )
            resolve(response)
          })
          .catch(error => {
            const errorData = error.response && error.response.data
            const messages = error.response && error.response.status === 404
              ? 'Endpoint import QC Reject tidak ditemukan. Pastikan backend sudah dipull dan route cache sudah dibersihkan.'
              : errorData && errorData.errors
              ? Object.values(errorData.errors).flat().join(' ')
              : (errorData && (errorData.message || errorData.exception))
                || (error.response && `HTTP ${error.response.status}`)
                || error.message
                || 'Import QC Reject gagal.'

            vm.$bvToast.toast(messages, {
              title: 'QC Reject Import Failed',
              variant: 'danger',
            })
            reject(error)
          })
      })
    },
    uploadQcRejectImages(ctx, { id, files }) {
      const formData = new FormData()
      files.forEach(file => {
        formData.append('images[]', file)
      })

      return new Promise((resolve, reject) => {
        axios
          .post(`/api/auth/qc-rejects/${id}/images`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            vm.$bvToast.toast('Foto QC Reject berhasil diupload', { title: 'QC Reject Images Uploaded' })
            resolve(response)
          })
          .catch(error => {
            const errorData = error.response && error.response.data
            const messages = errorData && errorData.errors
              ? Object.values(errorData.errors).flat().join(' ')
              : (errorData && (errorData.message || errorData.exception))
                || (error.response && `HTTP ${error.response.status}`)
                || error.message
                || 'Upload foto QC Reject gagal.'

            vm.$bvToast.toast(messages, {
              title: 'QC Reject Upload Failed',
              variant: 'danger',
            })
            reject(error)
          })
      })
    },
    deleteQcRejectImage(ctx, id) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/auth/qc-reject-images/${id}`)
          .then(response => {
            vm.$bvToast.toast('Foto QC Reject berhasil dihapus', { title: 'QC Reject Image Deleted' })
            resolve(response)
          })
          .catch(error => {
            const errorData = error.response && error.response.data
            const messages = errorData && errorData.errors
              ? Object.values(errorData.errors).flat().join(' ')
              : (errorData && (errorData.message || errorData.exception))
                || (error.response && `HTTP ${error.response.status}`)
                || error.message
                || 'Hapus foto QC Reject gagal.'

            vm.$bvToast.toast(messages, {
              title: 'QC Reject Delete Failed',
              variant: 'danger',
            })
            reject(error)
          })
      })
    },
  },
}
